import React, {useEffect, useState} from 'react';
import {useList} from "react-use";
import lodash from 'lodash';
import Checkbox from "../../../../../components/checkbox";

import {Collapse} from 'react-collapse';

function InningTopBatter(props) {
    const {selected} = props;
    const [isOpened, setIsOpened] = useState(false);
    const [listInningTopBatter, listInningTopBatterHelper] = useList([
        {
            value: "2",
            name: 'イニング先頭打者',
            checked: false,
        },
        {
            value: "1",
            name: 'イニング先頭打者以外',
            checked: false,
        },

    ]);
    useEffect(() => {
        if(selected.length === 0) return;
        selected.map(item => {
            const index = listInningTopBatter.findIndex(i => i.value === item);
            listInningTopBatter[index].checked = true;
        })
    },[selected])
    useEffect(() => {
        props.onChange(lodash.map(lodash.filter(listInningTopBatter,['checked', true]), 'value'));
    },[listInningTopBatter]);

    const onChange = (item, index) => {
        listInningTopBatterHelper.updateAt(index,{...item, checked: !item.checked});
    }

    return (
        <div className='group-filter-item'>
            <div className={'open-collapse'}>

                <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                    <h4>イニング先頭打者</h4>
                    <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{transform:isOpened === true && 'rotate(180deg)'}}/>
                </div>
                <Collapse isOpened={isOpened}>
                    <div style={{ display: 'flex'}}>
                        {listInningTopBatter.map((item,index) => {
                            return <div key={item.value} className={'search-main-advanced-checkbox'} >
                                <label>
                                    <Checkbox onChange={() => onChange(item, index)} value={item.value} checked={item.checked}/>
                                    {item.name}
                                </label>
                            </div>
                        })}
                    </div>
                </Collapse>
            </div>
            <div className={'close-collapse'}>

                <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                    <h4>イニング先頭打者</h4>
                </div>
                    <div style={{ display: 'flex'}}>
                        {listInningTopBatter.map((item,index) => {
                            return <div key={item.value} className={'search-main-advanced-checkbox'} >
                                <label>
                                    <Checkbox onChange={() => onChange(item, index)} value={item.value} checked={item.checked}/>
                                    {item.name}
                                </label>
                            </div>
                        })}
                    </div>


            </div>
        </div>
    )
}

export default InningTopBatter;
